import cogoToast from 'cogo-toast';
import { takeLatest, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import {
  DOWNLOAD_MANUAL_BOOKING_SUMMARY_EXCEL,
  DOWNLOAD_MANUAL_BOOKING_SUMMARY_EXCEL_SUCCESS,
  DOWNLOAD_MANUAL_BOOKING_SUMMARY_EXCEL_ERROR,
} from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* downloadManualBookingSummaryExcel({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/utility-request/manual-booking/draft/${payload.id}/summary-excel`,
      method: 'GET',
      headers: filteredHeaders,
      isOctetStream: true,
    });

    if (response.status === 200) {
      const blob = new Blob([response.data], {
        type: response.headers?.['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `manual_booking_summary_${payload.id}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      yield put({ type: DOWNLOAD_MANUAL_BOOKING_SUMMARY_EXCEL_SUCCESS, payload: true });
    } else {
      cogoToast.error(response?.response?.data?.message || 'Download failed');
      yield put({ type: DOWNLOAD_MANUAL_BOOKING_SUMMARY_EXCEL_ERROR, payload: response?.response?.data?.message });
    }
  } catch (error) {
    cogoToast.error('Download failed');
    yield put({ type: DOWNLOAD_MANUAL_BOOKING_SUMMARY_EXCEL_ERROR, payload: error });
  }
}

export function* watchDownloadManualBookingSummaryExcel() {
  yield takeLatest(DOWNLOAD_MANUAL_BOOKING_SUMMARY_EXCEL, downloadManualBookingSummaryExcel);
}

function* downloadManualBookingSummaryExcelSaga() {
  yield all([fork(watchDownloadManualBookingSummaryExcel)]);
}

export default downloadManualBookingSummaryExcelSaga;
